import Accordion from '@common/ui/accordion/Accordion';
import AccordionItem from '@common/ui/accordion/AccordionItem';
import useBreakpoint from '@common/utils/useBreakpoint';
import React, { useMemo } from 'react';
const CountrySelectorList = (props) => {
    const currentBreakpoint = useBreakpoint();
    const regionsData = props.regions;
    const regions = useMemo(() => {
        if (!regionsData) {
            return [];
        }
        return Object.keys(regionsData).map((key) => {
            return {
                region: key,
                countries: regionsData[key],
            };
        });
    }, [regionsData]);
    const returnRegion = (region) => {
        return regions.find((r) => r.region === region);
    };
    const countryList = (region) => (React.createElement("ol", { className: `country-selector--country-list country-selector--country-list--${region.region.toLowerCase()} ${props.isModal ? 'is-modal' : ''}` }, region.countries.map((country, i) => {
        var _a;
        return (React.createElement("li", { key: country.countryCode },
            React.createElement("p", { className: "font__cta" },
                React.createElement("span", null, country.name),
                country.external ? (React.createElement("a", { href: country.link },
                    React.createElement("span", { className: "visually-hidden" }, country.name),
                    React.createElement("span", null, country.countryCode))) : (React.createElement(React.Fragment, null, (_a = country.languagesMap) === null || _a === void 0 ? void 0 : _a.map((language, i) => (React.createElement("a", { key: language.seo, href: country.links[i], "aria-current": window.country === country.countryCode && window.language === language.base ? 'location' : undefined },
                    React.createElement("span", { className: "visually-hidden" }, country.name),
                    React.createElement("span", null, language.seo)))))))));
    })));
    const mobileLayout = () => (React.createElement(React.Fragment, null,
        React.createElement(Accordion, { className: "country-selector--accordion" }, regions.map((region) => (React.createElement(AccordionItem, { title: region.region, accordionId: `region_${region.region.toLowerCase()}`, headerClass: "country-selector--accordion-title", itemClass: "country-selector--accordion-item", key: region.region }, countryList(region)))))));
    const desktopLayout = () => (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "row" }, props.isModal ? (React.createElement(React.Fragment, null,
            regionsData.EUROPE && (React.createElement("div", { className: "inner-col-lg-8 inner-col-xxl-6" },
                React.createElement("h3", { className: "font__title" }, returnRegion('EUROPE').region),
                countryList(returnRegion('EUROPE')))),
            React.createElement("div", { className: "inner-col-lg-4 inner-offset-lg-2 inner-col-xxl-3 inner-offset-xxl-1" },
                regionsData.AMERICAS && (React.createElement("div", { className: "region" },
                    React.createElement("h3", { className: "font__title" }, returnRegion('AMERICAS').region),
                    countryList(returnRegion('AMERICAS')))),
                regionsData.ASIA && (React.createElement("div", { className: "region", style: { marginTop: '6rem' } },
                    React.createElement("h3", { className: "font__title" }, returnRegion('ASIA').region),
                    countryList(returnRegion('ASIA')))),
                regionsData.OCEANIA && (React.createElement("div", { className: "region", style: { marginTop: '6rem' } },
                    React.createElement("h3", { className: "font__title" }, returnRegion('OCEANIA').region),
                    countryList(returnRegion('OCEANIA'))))))) : (React.createElement(React.Fragment, null, regions.map((region) => (React.createElement("div", { className: `inner-col-lg-${region.region === 'EUROPE' ? '10' : '5'} `, key: region.region },
            React.createElement("h3", { className: "font__subtitle" }, region.region),
            countryList(region)))))))));
    if (!(regions === null || regions === void 0 ? void 0 : regions.length)) {
        return null;
    }
    // @ts-ignore
    return React.createElement("div", { className: "country-selector--list" }, currentBreakpoint < window.mqObj.lg ? mobileLayout() : desktopLayout());
};
export default CountrySelectorList;
